export default __webpack_public_path__ + "static/banner-socmed-mob-e411d5986f6ec003ca7fc8ad02d8a28d.webp";